/**
 * Passos do tutorial guiado do modo demonstração.
 *
 * Cada passo destaca (spotlight) um elemento da interface identificado por um
 * seletor CSS `data-tour`. Para adicionar novos passos, veja o guia em:
 *   .windsurf/conhecimento/frontend/tutorial-demo-spotlight.md
 *
 * Formato de um passo:
 *   {
 *     id:          string  // identificador único do passo
 *     selector:    string  // seletor CSS do elemento alvo (ex: '[data-tour="statusbar"]')
 *     title:       string  // título exibido no balão
 *     description: string  // texto explicativo
 *     placement:   'top' | 'bottom' | 'left' | 'right'  // posição do balão relativa ao alvo
 *     padding?:    number  // (opcional) respiro em px ao redor do destaque (default 8)
 *   }
 */
export const TUTORIAL_STEPS = [
  {
    id: 'statusbar',
    selector: '[data-tour="statusbar"]',
    title: 'Barra de Status',
    description:
      'Aqui no topo você acompanha a empresa selecionada e as estatísticas do projeto — quantidade de certificados, XMLs e SPEDs. Também é onde você troca entre o tema claro e escuro.',
    placement: 'bottom',
    padding: 6,
  },
  {
    id: 'menu',
    selector: '[data-tour="menu"]',
    title: 'Menu Lateral',
    description:
      'Navegue entre todas as telas do sistema por aqui. Você pode reorganizar os itens, criar categorias e marcar favoritos. Passe o mouse sobre um item para ver opções de edição.',
    placement: 'right',
    padding: 4,
  },
  {
    id: 'display',
    selector: '[data-tour="display"]',
    title: 'Tela de Arquivos',
    description:
      'Aqui é exibido o conteúdo da tela selecionada no menu. Você pode visualizar, editar e gerenciar todos os dados do projeto nesta área central.',
    placement: 'left',
    padding: 6,
    showCompleteButton: true,
  },
];
